import { useEffect } from "react";
import { Box } from "@mui/material";
import ContentSelector from "./ContentSelector";
import { useSearchParams } from "react-router-dom";
import { useAppSelector } from "../../../Redux/hooks";

const ProfileContentWrapper = ({
  showDownloadModal,
  setShowDownloadModal,
}: any) => {
  const menuType = useAppSelector((state) => state.participantTab.menuType);
  const [searchParams, setSearchParams] = useSearchParams();

  const participant = searchParams.get("participant") || "";

  useEffect(() => {
    const params = new URLSearchParams();
    params.set("participant", participant);

    setSearchParams(params, {
      replace: true,
    });
  }, [setSearchParams, participant, menuType]);

  return (
    <>
      <Box
        sx={{
          height: "100%",
        }}
      >
        <ContentSelector
          showDownloadModal={showDownloadModal}
          setShowDownloadModal={setShowDownloadModal}
        />
      </Box>
    </>
  );
};

export default ProfileContentWrapper;
